<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import { GetDataMethods, PostDataMethods } from "@/state/helpers";

/**
 * Orders Component
 */
export default {
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Users",
      countPage: 1,
      userData: [],
      currentPage: 1,
      filter: "",
      userId: 0,
      fields: [
        { key: "id", sortable: true, label: "ID" },
        { key: "username", sortable: false, label: "User Name" },
        { key: "phone", sortable: false, label: "Phone" },
        { key: "role", sortable: false, label: "Role" },
        { key: "points", sortable: false, label: "Current Balance" },
        { key: "deposit", sortable: false, label: "Deposit" },
        { key: "credit", sortable: false, label: "Debt" },
        { key: "commission", sortable: false, label: "Commission" },
        { key: "code_syriatell", sortable: false, label: "Syriatell Code" },
        { key: "password_syriatell", sortable: false, label: "Syriatell Password" },
        { key: "user_id", sortable: false, label: "User Id" },
        { key: "created_at", sortable: false, label: "Created At" },
        { key: "updated_at", sortable: false, label: "Updated At" },
        { key: "deleted_at", sortable: false, label: "Deleted At" },
        { key: "action_id", sortable: false, label: "Action" },
      ],
    };
  },
  computed: {
    /**
     * Total no. of records
     *
     */
    rows() {
      return this.countPage
    }

  },

  mounted() {
    this.GetUsersData();
  },



  watch: {
    currentPage: function () {
      this.GetUsersData();
    },
    filter: function () {
      this.GetUsersData()
    }
  },

  methods: {
    ...GetDataMethods,
    ...PostDataMethods,

    async GetUsersData() {
      let url = `get_all_users`;
      if (this.currentPage) {
        url += `?page=${this.currentPage}`
      }
      if (this.filter) {
        url += `&search=${this.filter}`
      }
      const res = await this.getData(url);
      this.userData = res.data.data.data;
      this.countPage = res.data.data.total;
    },

    async getAdmin(points) {
      const userInfo = localStorage.getItem('user');
      this.user = JSON.parse(userInfo);
      this.user.points = points;
      localStorage.setItem('user', JSON.stringify(this.user));
    },

    makeToast(variant = null, body = null, title = null) {
      this.$bvToast.toast(title, {
        title: `${body}`,
        variant: variant,
        solid: true,
      });
    },


  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body pt-0">
            <div class="row mt-4">
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search"
                      class="form-control form-control-sm ml-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="table-responsive">
              <b-table class="table-centered" :items="userData" :fields="fields" responsive="sm">
                <template v-slot:cell(updated_at)="data">
                  <div>{{ data.value | formatDate }}</div>
                </template>

                <template v-slot:cell(created_at)="data">
                  <div>{{ data.value | formatDate }}</div>
                </template>

                <template v-slot:cell(deleted_at)="data">
                  <div class="badge-soft-danger" style="background-color: rgb(251 245 246 / 18%)">
                    {{ data.value | formatDate }}</div>
                </template>

                <template v-slot:cell(action_id)="data">

                  <router-link :to="{ name: 'user', params: { id: data.value } }" class="mdi mdi-eye mr-2 font-size-18"
                    v-b-tooltip.hover title="Details">
                  </router-link>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :totalRows="rows" :per-page="perPage" aria-controls="user-tab">
                    </b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
